import { apiGet, apiSend } from './client';
import type { Environment } from '../constants';
import type { IContact, IContactInput } from '../types';

const base = (tenant: string) => `/tenants/${encodeURIComponent(tenant)}/contacts`;

export const getContacts = (
  environment: Environment,
  tenant: string,
): Promise<{ data: IContact[] }> => apiGet(environment, base(tenant));

export const createContact = (
  environment: Environment,
  tenant: string,
  input: IContactInput,
): Promise<{ data: IContact }> => apiSend(environment, base(tenant), 'POST', input);

export const updateContact = (
  environment: Environment,
  tenant: string,
  id: string,
  input: IContactInput,
): Promise<{ data: IContact }> =>
  apiSend(environment, `${base(tenant)}/${encodeURIComponent(id)}`, 'PUT', input);

export const deleteContact = (
  environment: Environment,
  tenant: string,
  id: string,
): Promise<void> => apiSend(environment, `${base(tenant)}/${encodeURIComponent(id)}`, 'DELETE');
